<header class="subHeader">
    <h2>{{ 'userNotificationsTable.label' | translate }}</h2>
</header>
<div class="grid-container">
    @let anyRowsValue = anyRows();
    @if (!anyRowsValue) {
        <div class="no-rows-overlay">
            <div class="subtitle">{{ 'grid.noNotifications' | translate }}</div>
        </div>
    }
    <ag-grid-angular
        class="ag-theme-alpine withoutTabs"
        [gridOptions]="extendedGridOptions"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        [enableCellTextSelection]="true"
        [statusBar]="statusBar"
        [ngClass]="{ hidden: !anyRowsValue }"
        (firstDataRendered)="onFirstDataRendered($event)"
        (sortChanged)="onSortChanged($event)"
        (filterChanged)="onFilterChanged($event)"
        (gridReady)="onGridReady($event)"
    />
</div>
